export class Grade {
    constructor(
        public courseName: string,
        public grade: string,
        public creditsEarned: number,
        public courseCode: string,
        public date: string
    ){}
}